import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const ReCaptchaIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "ReCaptcha",
    children: /*#__PURE__*/_jsx("path", {
      d: "M29.43 5.12a.66.66 0 0 0-.75.15l-1.94 1.9c-.59-.74-1.68-1.96-3.23-2.99-3.27-2.17-7.06-2.19-7.42-2.18H5.87c-.28 0-.53.17-.63.42-.11.27-.05.56.16.75l1.92 1.89c-.92.77-2.62 2.36-3.55 4.25-1.74 3.5-1.62 6.38-1.62 6.5v10.42a.676.676 0 0 0 1.17.48l1.92-1.91c1.29 1.53 5 5.2 10.93 5.2 6.27 0 9.77-4.08 9.92-4.26.23-.28.2-.68-.05-.93l-5.13-5.07a.68.68 0 0 0-.55-.19c-.2.02-.39.12-.51.29-.05.06-1.1 1.5-4.08 1.5-2.25 0-3.67-1.89-4.19-2.74l2.03-2.21c.19-.2.24-.5.13-.75a.69.69 0 0 0-.63-.41h-2.28c.16-.73.42-1.72.75-2.22.53-.84 1.38-1.44 1.88-1.76l2.15 2.17c.2.2.5.26.75.16.26-.11.43-.36.43-.64v-2.3c.58.09 1.4.29 2.01.76.94.72 1.51 1.52 1.78 1.99l-2.11 2.1c-.2.2-.26.5-.15.75.1.26.36.42.63.42h10.2c.39 0 .69-.3.69-.69V5.75c0-.28-.17-.53-.42-.63Zm-17.9 11.49-1.31 1.43c-.19.2-.24.51-.12.76.07.16 1.9 3.92 5.67 3.92 2.48 0 3.95-.88 4.66-1.5l4.15 4.09c-1.06 1-3.99 3.31-8.41 3.31-6.59 0-10.27-5.2-10.3-5.25a.63.63 0 0 0-.51-.29H5.3c-.18 0-.36.07-.49.2l-1.3 1.29v-7.96h8Zm3.88-5.35L14.07 9.9a.67.67 0 0 0-.79-.13c-.08.03-1.84.9-2.86 2.49-.49.75-.82 2.06-.97 2.82H3.54c.07-.97.35-2.93 1.45-5.16C6.13 7.6 8.73 5.68 8.76 5.66c.17-.13.27-.31.28-.52.02-.2-.06-.4-.2-.54L7.56 3.37h7.85v7.88Zm13.07 4.02h-7.84L21.92 14c.2-.19.26-.5.16-.75-.03-.06-.71-1.63-2.44-2.94-.93-.71-2.12-.97-2.85-1.07V3.41c1.19.08 3.75.44 5.97 1.92 2.11 1.41 3.32 3.25 3.33 3.27.12.17.3.29.51.31.2.03.41-.05.56-.19l1.32-1.32z"
    })
  }));
};